import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DialogFormActionsComponent } from './dialog-form-actions.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  templateUrl: 'confirm-delete-dialog.component.html',
  imports: [MatDialogModule, MatButtonModule, MatToolbarModule, DialogFormActionsComponent, TranslateModule],
  host: { 'data-testid': 'confirm-delete-dialog' },
})
export class ConfirmDeleteDialogComponent {
  data = inject<{
    name?: string;
    type?: string;
    title?: string;
    message?: string;
    confirmLabel?: string;
    confirmColor?: 'primary' | 'warn';
  }>(MAT_DIALOG_DATA);
}
